import { motion } from 'framer-motion';

const Philosophy = () => {
  const principles = [
    'Every problem deserves to be made significantly more complicated than it initially appears',
    'Over-thinking is not a flaw — it is a billable service and we are very good at it',
    'Solutions are temporary; a properly over-complicated problem is eternal',
    'As a bonus, our process reliably generates new problems at no additional charge',
    'True expertise means applying 14 frameworks to a situation that needed zero',
    'Your problems should never run out — that is not a failure, that is our business model',
  ];

  return (
    <section className="bg-dark-gray py-36">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-charcoal border-l-8 border-gold p-16 rounded-lg"
        >
          <h2 className="text-4xl font-bold text-white mb-8">Our Philosophy on Problems</h2>
          <p className="text-xl text-white leading-relaxed mb-12">
            At The Real Problem Company, we believe that a simple problem is a wasted opportunity. 
            Our philosophy is rooted in the conviction that every issue — no matter how minor — 
            deserves to be thoroughly over-thought, meticulously over-complicated, and carefully 
            escalated until it reaches its full, magnificent potential. And as a bonus, our process 
            almost always produces new problems along the way. We consider this a feature, not a bug.
          </p>

          <div className="space-y-4 mb-12">
            {principles.map((principle, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="flex items-start gap-4"
              >
                <div className="w-2 h-2 rounded-full bg-gold mt-2 flex-shrink-0"></div>
                <p className="text-lg text-light-gray">{principle}</p>
              </motion.div>
            ))}
          </div>

          <div className="bg-black/50 border-2 border-gold/30 rounded-lg p-8 mb-12">
            <p className="text-xl text-white italic leading-relaxed mb-4">
              "We don't believe in quick fixes or superficial solutions. We believe in deep, 
              recursive, multi-layered problem recognition that transforms a manageable situation 
              into something truly formidable. Some call it overthinking. We call it excellence. 
              Our clients call it 'why did I come here.' We call that a bonus problem."
            </p>
          </div>

          <div className="text-right">
            <div className="text-4xl font-serif italic text-gold">Dr. Marcus Thornwell</div>
            <div className="text-light-gray text-sm mt-2">Founder & Chief Problem Officer</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Philosophy;